module.exports = __webpack_public_path__ + "img/OurStory_Img4.16ddbd3e.png";